import React from 'react';
import { Tooltip } from '@mui/material';
import colors from '../../Utils/colors';
import images from '../../Utils/images';
import CheerioButton from '../../Components/CheerioButton';

type WalletModalOBProps = {
  setIsModalOpen: (open: boolean) => void;
  walletCurrency: string; // e.g., 'INR' | 'USD'
  walletBalance?: number | null;
  onclickAddBalance: () => void;
  onclickPaymentHistory: () => void;
};

const WalletModalOB: React.FC<WalletModalOBProps> = ({
  setIsModalOpen,
  walletCurrency,
  walletBalance,
  onclickAddBalance,
  onclickPaymentHistory,
}) => {
  return (
    <>
      <div
        className="Column justify-content-start"
        style={{
          width: 375,
          height: 'auto',
          borderRadius: 12,
          border: `1px solid ${colors.borderwhite}`,
          padding: 16,
          backgroundColor: colors.white01,
          position: 'fixed',
          top: 80,
          right: 80,
          zIndex: 1000,
        }}
      >
        <div className="Row w-100" style={{ borderBottom: `1px solid ${colors.borderwhite}`, paddingBlockEnd: 16 }}>
          <p style={{ fontWeight: 600 }}>{'Wallet'}</p>
          <div className="Row justify-content-start" style={{ columnGap: 16 }}>
            <Tooltip title="Payment History">
              <img
                src={images.PAYBLACK}
                alt="Payment History"
                style={{
                  height: 24,
                  width: 24,
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  onclickPaymentHistory();
                }}
              />
            </Tooltip>
            <img
              src={images.CMClose}
              alt="Close"
              style={{ height: 24, width: 24, objectFit: 'contain', cursor: 'pointer' }}
              onClick={() => {
                setIsModalOpen(false);
              }}
            />
          </div>
        </div>
        <div className="Row w-100" style={{ paddingBlockStart: 16 }}>
          <p style={{ fontSize: 20, fontWeight: 600 }}>
            {walletCurrency === 'INR' ? `₹${walletBalance ?? 0}` : `$${walletBalance ?? 0}`}
          </p>
          <CheerioButton
            btnText={`Add Balance`}
            borderStyle={{borderColor:colors.black}}
            textStyle={{}}
            backColor={colors.white01}
            disabled={false}
            icon={null}
            id={'add_balance'}
            onclick={() => {
              onclickAddBalance();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default WalletModalOB;
